import { render, staticRenderFns } from "./PartnerCreateUpdate.vue?vue&type=template&id=10cc82b0&"
import script from "./PartnerCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./PartnerCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCreateUpdate.vue?vue&type=style&index=0&id=10cc82b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VSpacer,VTextField,VTextarea})
